module.exports = __webpack_public_path__ + "img/CNN-COVER.19cafa40.png";